import { render, staticRenderFns } from "./ImportResidentModal.vue?vue&type=template&id=21f7dd43&"
import script from "./ImportResidentModal.vue?vue&type=script&lang=js&"
export * from "./ImportResidentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f7dd43')) {
      api.createRecord('21f7dd43', component.options)
    } else {
      api.reload('21f7dd43', component.options)
    }
    module.hot.accept("./ImportResidentModal.vue?vue&type=template&id=21f7dd43&", function () {
      api.rerender('21f7dd43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/condoMngt/component/ImportResidentModal.vue"
export default component.exports